//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiClose, mdiAlertOutline } from '@mdi/js'

export default {
  name: 'GlobalError',
  props: {
    globalError: {
      type: [String],
      default: undefined,
    },
  },
  data() {
    return {
      icons: {
        mdiClose,
        mdiAlertOutline,
      },
      showContainer: false,
    }
  },
  watch: {
    globalError: {
      handler(value) {
        this.showContainer = !!(value && value.length > 0)
      },
      deep: true,
    },
  },
  created() {
    this.showContainer = !!(this.globalError && this.globalError.length > 0)
    // this.finalRules = this.rules
    // this.finalRules.push(this.requiredWith)
  },
  methods: {
    closeHandler() {
      this.showContainer = false
      this.$emit('clearError')
    },
  },
}
